// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"5281cc5e","453":"4351f10a","454":"2629bef4","702":"cde62e56"}[chunkId] + ".chunk.js";
};